class ColumnsData {
    static requests() {
        let items = [
            {id: "full_name", label: "ФИО"},
            {id: 'phone', label: 'Телефон'},
            {id: 'phone2', label: 'Телефон 2'},
            {id: 'phone3', label: 'Телефон 3'},
            {id: 'phone4', label: 'Телефон 4'},
            {id: 'phone5', label: 'Телефон 5'},
            {id: 'phone6', label: 'Телефон 6'},
            {id: 'phone_region', label: 'Регион (телефон)'},
            {id: 'ip', label: 'IP'},
            {id: 'ip_region', label: 'Регион (IP)'},
            {id: 'registration_region', label: 'Регион регистрации'},
            {id: 'residence_region', label: 'Регион проживания'},
            {id: 'discount', label: 'Скидка'},
            {id: 'primary_car_brand_name', label: 'Марка (первичная)'},
            {id: 'primary_car_model_name', label: 'Модель (первичная)'},
            {id: 'primary_car_modification_name', label: 'Модификация (первичная)'},
            {id: 'primary_car_complete_name', label: 'Комплектация (первичная)'},
            {id: 'primary_car_cost', label: 'Стоимость (первичная)'},
            {id: 'primary_car_color', label: 'Цвет (первичный)'},
            {id: 'primary_car_year', label: 'Год (первичный)'},
            {id: 'primary_car_condition', label: 'Состояние (первичное)'},
            {id: 'primary_car_link', label: 'Ссылка на авто'},
            {id: 'car_brand_name', label: 'Марка'},
            {id: 'car_model_name', label: 'Модель'},
            {id: 'car_modification_name', label: 'Модификация'},
            {id: 'car_complete_name', label: 'Комплектация'},
            {id: 'car_cost', label: 'Стоимость'},
            {id: 'car_color', label: 'Цвет'},
            {id: 'car_year', label: 'Год'},
            {id: 'car_condition', label: 'Состояние'},
            {id: 'yclid', label: 'yclid'},
            {id: 'utm_source', label: 'utm_source'},
            {id: 'utm_medium', label: 'utm_medium'},
            {id: 'utm_campaign', label: 'utm_campaign'},
            {id: 'utm_term', label: 'utm_term'},
            {id: 'utm_content', label: 'utm_content'},
            {id: 'referer', label: 'referer'},
            {id: 'call_date', label: 'Дата звонка'},
            {id: 'visit_date', label: 'Предпол. визит'},
            {id: 'visited_at', label: 'Факт. визит'},
            {id: 'purchased_at', label: 'Дата продажи'},
            {id: 'type', label: 'Тип'},
            {id: 'credit_initial_payment', label: 'Перв. взнос'},
            {id: 'credit_term', label: 'Срок кредита'},
            {id: 'status', label: 'Статус'},
            {id: 'in_credit_department', label: 'В кредитном'},
            {id: 'in_credit_department_datetime', label: 'Отправлен в КО'},
            {id: 'visited_credit_department_at', label: 'Сел в КО'},
            {id: 'credit_status', label: 'Кред. статус'},
            {id: 'bank_decision', label: 'Решение банка'},
            {id: 'is_trade_in', label: 'Trade-In'},
            {id: 'is_utilisation', label: 'Утилизация'},
            {id: 'source', label: 'Источник'},
            {id: 'operator_name', label: 'Оператор'},
            {id: 'sales_manager_name', label: 'Менеджер'},
            {id: 'credit_manager_name', label: 'Кред. спец'},
            {id: 'created_at', label: 'Создан'},
            {id: 'credit_score', label: '***'}, // Скоринг
        ];
        let default_ids = [
            "created_at",
            "visit_date",
            "full_name",
            "phone",
            "car_brand_name",
            "car_model_name",
            "car_condition",
            "type",
            "in_credit_department",
            "credit_score",
            "residence_region",
            "operator_name",
            "status",
        ]
        return {
            all: items,
            default: _.map(default_ids, id => _.find(items, {id: id})),
            added: ["credit_score", "bank_decision", "phone4", "phone5", "phone6", "yclid"],
        };
    }

    static credit_department() {
        let items = [
            {id: "full_name", label: "ФИО"},
            // {id: 'phone', label: 'Телефон'},
            // {id: 'phone2', label: 'Телефон 2'},
            // {id: 'phone3', label: 'Телефон 3'},
            // {id: 'phone_region', label: 'Регион (телефон)'},
            // {id: 'ip', label: 'IP'},
            // {id: 'ip_region', label: 'Регион (IP)'},
            {id: 'registration_region', label: 'Регион регистрации'},
            {id: 'residence_region', label: 'Регион проживания'},
            {id: 'discount', label: 'Скидка'},
            // {id: 'primary_car_brand_name', label: 'Марка (первичная)'},
            // {id: 'primary_car_model_name', label: 'Модель (первичная)'},
            // {id: 'primary_car_modification_name', label: 'Модификация (первичная)'},
            // {id: 'primary_car_complete_name', label: 'Комплектация (первичная)'},
            // {id: 'primary_car_cost', label: 'Цена (первичная)'},
            // {id: 'primary_car_color', label: 'Цвет (первичный)'},
            // {id: 'primary_car_year', label: 'Год (первичный)'},
            // {id: 'primary_car_condition', label: 'Состояние (первичное)'},
            // {id: 'primary_car_link', label: 'Ссылка на авто'},
            // {id: 'car_brand_name', label: 'Марка'},
            // {id: 'car_model_name', label: 'Модель'},
            // {id: 'car_modification_name', label: 'Модификация'},
            // {id: 'car_complete_name', label: 'Комплектация'},
            {id: 'car_cost', label: 'Стоимость'},
            // {id: 'car_color', label: 'Цвет'},
            // {id: 'car_year', label: 'Год'},
            {id: 'car_condition', label: 'Состояние'},
            // {id: 'utm_source', label: 'utm_source'},
            // {id: 'utm_medium', label: 'utm_medium'},
            // {id: 'utm_campaign', label: 'utm_campaign'},
            // {id: 'utm_term', label: 'utm_term'},
            // {id: 'utm_content', label: 'utm_content'},
            // {id: 'referer', label: 'referer'},
            {id: 'call_date', label: 'Дата звонка'},
            {id: 'visit_date', label: 'Предпол. визит'},
            {id: 'visited_at', label: 'Факт. визит'},
            {id: 'purchased_at', label: 'Дата продажи'},
            {id: 'type', label: 'Тип'},
            {id: 'credit_initial_payment', label: 'Перв. взнос'},
            {id: 'credit_term', label: 'Срок кредита'},
            {id: 'status', label: 'Статус'},
            {id: 'in_credit_department', label: 'В кредитном'},
            {id: 'in_credit_department_datetime', label: 'Отправлен в КО'},
            {id: 'visited_credit_department_at', label: 'Сел в КО'},
            {id: 'credit_status', label: 'Кред. статус'},
            {id: 'bank_decision', label: 'Решение банка'},
            {id: 'is_trade_in', label: 'Trade-In'},
            {id: 'is_utilisation', label: 'Утилизация'},
            // {id: 'source', label: 'Источник'},
            {id: 'operator_name', label: 'Оператор'},
            {id: 'sales_manager_name', label: 'Менеджер'},
            {id: 'credit_manager_name', label: 'Кред. спец'},
            {id: 'created_at', label: 'Создан'},
            {id: 'credit_score', label: '***'}, // Скоринг

            {id: "car", label: "Авто"},
            {id: "tinkoff", label: "Т-Банк", type: "bank"},
            {id: "absolut", label: "Абсолют", type: "bank"},
            {id: "zenit", label: "Зенит", type: "bank"},
            {id: "orange", label: "Оранжевый", type: "bank"},
            {id: "sovcom", label: "Совком", type: "bank"},
            {id: "locko", label: "Локо", type: "bank"},
            {id: "expo", label: "Экспо", type: "bank"},
            {id: "primsoc", label: "Примсоц", type: "bank"},
            {id: "rusnarbank", label: "Руснарбанк", type: "bank"},
            {id: "driveclick", label: "Драйв Клик", type: "bank"},
            {id: "soyuz", label: "Союз", type: "bank"},
            {id: "bystrobank", label: "БыстроБанк", type: "bank"},
            {id: "rosbank", label: "Росбанк", type: "bank"},
            {id: "vologzhanin", label: "Вологжанин", type: "bank"},
            {id: "atb", label: "АТБ", type: "bank"},
            {id: "otpbank", label: "ОТП", type: "bank"},
            {id: "crediteurope", label: "Кредит Европа", type: "bank"},
            {id: "cashdrive", label: "Кэшдрайв", type: "bank"},
            {id: "vtb", label: "ВТБ", type: "bank"},
            {id: "rosgosstrah", label: "РосГосСтрах", type: "bank"},
            {id: "otkrytie", label: "Открытие", type: "bank"},
            {id: "alfabank", label: "Альфа-Банк", type: "bank"},
            {id: "freedom-finance", label: "Фридом Финанс", type: "bank"},
            {id: "uralsib", label: "Уралсиб", type: "bank"},
            {id: "gazprombank", label: "Газпромбанк", type: "bank"},
            {id: "broxi", label: "Broxi (Брокер)", type: "bank"},
            {id: "mbrusbank", label: "МБ РУС Банк", type: "bank"},
            {id: "ingobank", label: "Ингосстрах Банк", type: "bank"},
            {id: "sber", label: "СберБанк", type: "bank"},
            {id: "sngb", label: "СНГБанк", type: "bank"},
            {id: "psbank", label: "Промсвязьбанк", type: "bank"},
            {id: "levoberezhny", label: "Левобережный", type: "bank"},
            {id: "mts", label: "МТС Банк", type: "bank"},
            {id: "renessans", label: "Ренессанс Банк", type: "bank"},
            {id: "energobank", label: "Энергобанк", type: "bank"},
            {id: "appruvo", label: "Appruvo", type: "bank"},
            {id: "europlan", label: "Европлан", type: "bank"},
            {id: "reso", label: "Ресо", type: "bank"},
            {id: "autofinancebank", label: "Авто Финанс Банк", type: "bank"},
            {id: "royalcreditbank", label: "Роял Кредит Банк", type: "bank"},
        ];

        let default_ids = [
            "visited_credit_department_at",
            "full_name",
            "credit_initial_payment",
            "car",
            "credit_status",
            "bank_decision",
            "credit_score",
            "tinkoff",
            "absolut",
            "zenit",
            "orange",
            "sovcom",
            "locko",
            "expo",
            "primsoc",
            "rusnarbank",
            "driveclick",
            "soyuz",
            "bystrobank",
            "rosbank",
            "vologzhanin",
            "atb",
            "otpbank",
            "crediteurope",
            "cashdrive",
            "vtb",
            "rosgosstrah",
            "otkrytie",
            "alfabank",
            "sales_manager_name",
            "credit_manager_name",
        ];
        return {
            all: items,
            default: _.map(default_ids, id => _.find(items, {id: id})),
            added: ["atb", "otkrytie", "alfabank", "freedom-finance", "credit_score", "bank_decision", "uralsib", "driveclick", "locko", "orange","sovcom","locko","expo","soyuz","broxi", "mbrusbank", "ingobank", "sber", "sngb", "psbank", "levoberezhny","mts","renessans", "energobank", "appruvo", "europlan", "reso", "autofinancebank", "royalcreditbank"],
        };
    }

    static sales_department() {
        let items = [
            {id: "full_name", label: "ФИО"},
            {id: 'phone', label: 'Телефон'},
            // {id: 'phone2', label: 'Телефон 2'},
            // {id: 'phone3', label: 'Телефон 3'},
            // {id: 'phone_region', label: 'Регион (телефон)'},
            // {id: 'ip', label: 'IP'},
            // {id: 'ip_region', label: 'Регион (IP)'},
            {id: 'registration_region', label: 'Регион регистрации'},
            {id: 'residence_region', label: 'Регион проживания'},
            {id: 'discount', label: 'Скидка'},
            // {id: 'primary_car_brand_name', label: 'Марка (первичная)'},
            // {id: 'primary_car_model_name', label: 'Модель (первичная)'},
            // {id: 'primary_car_modification_name', label: 'Модификация (первичная)'},
            // {id: 'primary_car_complete_name', label: 'Комплектация (первичная)'},
            // {id: 'primary_car_cost', label: 'Цена (первичная)'},
            // {id: 'primary_car_color', label: 'Цвет (первичный)'},
            // {id: 'primary_car_year', label: 'Год (первичный)'},
            // {id: 'primary_car_condition', label: 'Состояние (первичное)'},
            // {id: 'primary_car_link', label: 'Ссылка на авто'},
            // {id: 'car_brand_name', label: 'Марка'},
            // {id: 'car_model_name', label: 'Модель'},
            // {id: 'car_modification_name', label: 'Модификация'},
            // {id: 'car_complete_name', label: 'Комплектация'},
            {id: 'car_cost', label: 'Стоимость'},
            // {id: 'car_color', label: 'Цвет'},
            // {id: 'car_year', label: 'Год'},
            {id: 'car_condition', label: 'Состояние'},
            // {id: 'utm_source', label: 'utm_source'},
            // {id: 'utm_medium', label: 'utm_medium'},
            // {id: 'utm_campaign', label: 'utm_campaign'},
            // {id: 'utm_term', label: 'utm_term'},
            // {id: 'utm_content', label: 'utm_content'},
            // {id: 'referer', label: 'referer'},
            {id: 'call_date', label: 'Дата звонка'},
            {id: 'visit_date', label: 'Предпол. визит'},
            {id: 'visited_at', label: 'Факт. визит'},
            {id: 'purchased_at', label: 'Дата продажи'},
            {id: 'type', label: 'Тип'},
            // {id: 'credit_initial_payment', label: 'Перв. взнос'},
            // {id: 'credit_term', label: 'Срок кредита'},
            {id: 'status', label: 'Статус'},
            {id: 'credit_status', label: 'Кред. статус'},
            {id: 'in_credit_department', label: 'В кредитном'},
            {id: 'in_credit_department_datetime', label: 'Отправлен в КО'},
            {id: 'visited_credit_department_at', label: 'Сел в КО'},
            // {id: 'is_trade_in', label: 'Trade-In'},
            // {id: 'is_utilisation', label: 'Утилизация'},
            // {id: 'source', label: 'Источник'},
            // {id: 'operator_name', label: 'Оператор'},
            {id: 'sales_manager_name', label: 'Менеджер'},
            // {id: 'credit_manager_name', label: 'Кред. спец'},
            // {id: 'created_at', label: 'Создан'},
            {id: 'credit_score', label: '***'}, // Скоринг

            {id: "car", label: "Авто"},
        ];

        let default_ids = [
            "visit_date",
            "visited_at",
            "full_name",
            "phone",
            "car",
            "car_condition",
            "in_credit_department",
            "registration_region",
            "sales_manager_name",
            "status",
            "credit_score",
        ];
        return {
            all: items,
            default: _.map(default_ids, id => _.find(items, {id: id})),
            added: ["credit_score"],
        };
    }

    static operations_cash() {
        let items = [
            {id: "created_at", label: "Создана"},
            {id: "salon_legal_entity", label: "Юр. лицо"},
            {id: "category", label: "Статья"},
            {id: "counteragent", label: "Контрагент"},
            {id: "document_type", label: "Документ"},
            {id: "document_number", label: "№ документа"},
            {id: "document_date", label: "Дата документа"},
            {id: "car", label: "Автомобиль"},
            {id: "car_vin", label: "VIN"},
            {id: "platform", label: "Площадка"},
            // {id: "amount", label: "Сумма"},
            {id: "active", label: "Актив"},
            {id: "passive", label: "Пассив"},
            {id: "vat", label: "НДС"},
            {id: "comment", label: "Комментарий"},
            {id: "creator", label: "Создал"},
            {id: "updater", label: "Обновил"},
        ];

        let default_ids = [
            "created_at",
            "salon_legal_entity",
            "category",
            "counteragent",
            "document_type",
            "document_number",
            "document_date",
            "car",
            "car_vin",
            "platform",
            // "amount",
            "active",
            "passive",
            "vat",
            "comment",
            "creator",
            "updater",
        ];
        return {
            all: items,
            default: _.map(default_ids, id => _.find(items, {id: id})),
            added: ["active", "passive"],
        };
    }

    static operations_bank() {
        let init = _.cloneDeep(this.operations_cash());
        init.all.push({id: "bank", label: "Банк"});
        init.default.push("bank");
        init.added.push("bank");

        return init;
    }

    static operations_cars() {
        return {
            all: _.filter(this.operations_cash().all, i => ["category"].indexOf(i.id) === -1),
            default: _.filter(this.operations_cash().default, i => ["category"].indexOf(i) === -1),
            added: _.filter(this.operations_cash().added, i => ["category"].indexOf(i) === -1),
        }
    }

    static car_warehouse() {
        let items = [
            {id: "brand_name", label: "Марка"},
            {id: "model_name", label: "Модель"},
            {id: "generation_name", label: "Поколение"},
            {id: "modification_name", label: "Модификация"},
            {id: "complectation_name", label: "Комплектация"},
            {id: "complectation_desc", label: "Описание комплектации"},
            {id: "defects_desc", label: "Дефекты и повреждения"},
            {id: "cost", label: "Стоимость"},
            {id: "cost_accumulated", label: "Накопленная стоимость"},
            {id: "cost_increase", label: "Удорожание"},
            {id: "pts_vin", label: "VIN"},
            {id: "pts_year", label: "Год"},
            {id: "pts_engine_volume", label: "Двигатель"},
            {id: "pts_engine_power", label: "Л.С."},
            {id: "gearbox_type", label: "КПП"},
            {id: "drive_type", label: "Привод"},
            {id: "body_type", label: "Кузов"},
            {id: "pts_color", label: "Цвет"},
            {id: "condition", label: "Состояние"},
            {id: "mileage", label: "Пробег"},
            {id: "status", label: "Статус"},
            {id: "legal_owner", label: "Собственник"},
            {id: "actual_owner", label: "Владелец"},
            {id: "platform", label: "Площадка"},
            {id: "comment", label: "Комментарий"},
            {id: "created_at", label: "Создана"},
            {id: "purchased_at", label: "Куплена"},
            {id: "arrived_at", label: "Пришла"},
            {id: "age", label: "Возраст"},
            {id: "sold_at", label: "Продана"},
            {id: "creator", label: "Создал"},
            {id: "restrictions", label: "Ограничения"},
            {id: "reports", label: "Отчеты"},
            {id:"expenses_5", label:"Возврат ДС"},
            {id:"expenses_10", label:"Запчасти"},
            {id:"expenses_11", label:"Доп оборудование"},
            {id:"expenses_16", label:"Оформление"},
            {id:"expenses_17", label:"Предпродажка"},
            {id:"expenses_19", label:"Страхование"},
            {id:"expenses_21", label:"Транспорт"},
            {id:"expenses_23", label:"Шапка"},
            {id:"expenses_24", label:"Мойка"},
            {id:"expenses_26", label:"Химчистка"},
            {id:"expenses_27", label:"Скидка"},
            {id:"expenses_31", label:"Ремонт"},
            {id:"expenses_32", label:"Штрафы"},
            {id:"expenses_33", label:"Процент по экв"},
            {id:"expenses_34", label:"Прочее"},
        ];
        let items_slugs = _.map(items, i => i.id);

        let default_ids = [
            "brand_name",
            "model_name",
            "generation_name",
            "modification_name",
            "complectation_name",
            "complectation_desc",
            "defects_desc",
            "cost",
            "pts_vin",
            "pts_year",
            "pts_engine_volume",
            "pts_engine_power",
            "gearbox_type",
            "drive_type",
            "body_type",
            "pts_color",
            "condition",
            "mileage",
            "status",
            "legal_owner",
            "actual_owner",
            "platform",
            "restrictions",
            "reports",
            "comment",
            "created_at",
            "purchased_at",
            "arrived_at",
            "age",
            "sold_at",
            "creator",
        ];
        return {
            all: items,
            default: _.map(default_ids, id => _.find(items, {id: id})),
            added: ["cost_accumulated", "cost", "cost_increase", "restrictions", "reports", "complectation_desc", "defects_desc", "age"],
            roles: { // разрешенные столбцы по ролям
                admin: items_slugs,
                head_of_call_center: _.filter(items_slugs, i => ["cost", "cost_accumulated", "cost_increase", "mileage", "legal_owner", "actual_owner", "comment", "created_at", "purchased_at", "arrived_at", "sold_at", "creator", "pts_vin"].indexOf(i) === -1),
                operator: _.filter(items_slugs, i => ["cost", "cost_accumulated", "cost_increase", "mileage", "legal_owner", "actual_owner", "comment", "created_at", "purchased_at", "arrived_at", "sold_at", "creator"].indexOf(i) === -1),
                head_of_sales_department: _.filter(items_slugs, i => ["legal_owner","actual_owner"].indexOf(i) === -1),
                sales_manager: _.filter(items_slugs, i => ["cost_accumulated","cost_increase","legal_owner","actual_owner","created_at","purchased_at","creator"].indexOf(i) === -1),
                head_of_credit_department: _.filter(items_slugs, i => ["legal_owner","actual_owner"].indexOf(i) === -1),
                credit_manager: _.filter(items_slugs, i => ["cost_accumulated", "cost_increase", "legal_owner", "actual_owner", "platform", "created_at", "purchased_at", "arrived_at", "sold_at", "creator",].indexOf(i) === -1),
                cashier: items_slugs,
                investor: items_slugs,
                ad_agency: _.filter(items_slugs, i => ["cost", "cost_accumulated", "cost_increase", "legal_owner", "actual_owner", "comment", "created_at", "purchased_at", "arrived_at", "sold_at", "creator"].indexOf(i) === -1),
                supervisor: items_slugs,
            },
        };
    }

    static deals() {
        let items = [
            {id: "created_at", label: "Создано"},
            {id: "status", label: "Статус"},
            {id: "buyer", label: "Покупатель"},
            {id: "document_number", label: "ДКП №"},
            {id: "document_date", label: "ДКП дата"},
            {id: "platform", label: "Площадка"},
            {id: "salon_legal_entity", label: "Юр лицо площадки"},
            {id: "document_signatory", label: "Подписант"},
            {id: "payment_type", label: "Оплата"},
            {id: "is_trade_in", label: "Trade-In"},
            {id: "sale_car", label: "Машина"},
            {id: "sale_car_pts_vin", label: "VIN"},
            {id: "sale_car_cost", label: "Стоимость"},
            {id: "sale_car_cost_accumulated", label: "Накопленная стоимость"},
            {id: "sale_car_cost_increase", label: "Удорожание"},
            {id: "sale_amount", label: "Сумма продажи"},
            {id: "profit", label: "Прибыль"},
            {id: "sale_initial_payment", label: "Перв. платеж (факт)"},
            {id: "credit_bank", label: "Банк"},
            {id: "credit_document_date", label: "Дата кред. договора"},
            {id: "credit_sale_amount", label: "Цена авто по кред. дог."},
            {id: "credit_amount", label: "Сумма кредита (полная)"},
            {id: "credit_amount_for_car", label: "Сумма кредита (за авто)"},
            {id: "credit_term", label: "Срок кредита"},
            {id: "credit_monthly_payment", label: "Ежемес. платеж"},
            {id: "credit_initial_payment", label: "ПВ по кред. договору"},
            {id: "credit_bank_debt", label: "Задолженность банка"},
            {id: "creator", label: "Создал"},


        ];
        let items_slugs = _.map(items, i => i.id);

        let default_ids = [
            "created_at",
            "status",
            "buyer",
            "document_number",
            "document_date",
            "platform",
            "salon_legal_entity",
            "document_signatory",
            "payment_type",
            "is_trade_in",
            "sale_car",
            "sale_car_pts_vin",
            "sale_car_cost",
            "sale_car_cost_accumulated",
            "sale_car_cost_increase",
            "sale_amount",
            "profit",
            "sale_initial_payment",
            "credit_bank",
            "credit_document_date",
            "credit_sale_amount",
            "credit_amount",
            "credit_amount_for_car",
            "credit_term",
            "credit_monthly_payment",
            "credit_initial_payment",
            "credit_bank_debt",
            "creator",
        ];
        return {
            all: items,
            default: _.map(default_ids, id => _.find(items, {id: id})),
            added: ['credit_bank_debt', 'credit_amount_for_car'],
            roles: { // разрешенные столбцы по ролям
                admin: items_slugs,
                head_of_call_center: [],
                operator: [],
                head_of_sales_department: items_slugs,
                sales_manager: _.filter(items_slugs, i => ["sale_car_cost", "sale_car_cost_accumulated", "sale_car_cost_increase", "profit", "creator", "credit_bank_debt"].indexOf(i) === -1),
                head_of_credit_department: items_slugs,
                credit_manager: _.filter(items_slugs, i => ["sale_car_cost", "sale_car_cost_accumulated", "sale_car_cost_increase", "profit", "credit_bank_debt"].indexOf(i) === -1),
                cashier: items_slugs,
                investor: _.filter(items_slugs, i => ["credit_bank_debt"].indexOf(i) === -1),
                supervisor: _.filter(items_slugs, i => ["credit_bank_debt"].indexOf(i) === -1),
            },
        };
    }
    static report_sales() {
        let items = [
            {id:"platform", label:"Площадка"},
            {id:"sale_date", label:"Дата продажи"},
            {id:"sale_car", label:"Автомобиль"},
            {id:"sale_car_pts_vin", label:"VIN"},
            {id:"sale_car_condition", label:"Состояние"},
            {id:"buyer", label:"Покупатель"},
            {id:"payment_type", label:"Оплата"},
            {id:"credit_bank", label:"Банк"},
            {id:"sale_car_cost_shipment", label:"Приход"},
            {id:"sale_car_cost_accumulated", label:"Накопленная стоимость"},
            {id:"sale_car_cost_increase", label:"Удорожание"},
            {id:"expenses_cap", label:"Шапка"},
            {id:"expenses_transport", label:"Транспорт"},
            {id:"expenses_broker", label:"Брокер"},
            {id:"expenses_additional_equipment", label:"Доп оборудование"},
            {id:"expenses_discount", label:"Скидка"},
            {id:"expenses_3", label:"Перемещение а/м"},
            {id:"expenses_5", label:"Возврат ДС"},
            {id:"expenses_10", label:"Запчасти"},
            {id:"expenses_14", label:"Налоги"},
            {id:"expenses_16", label:"Оформление"},
            {id:"expenses_17", label:"Предпродажка"},
            {id:"expenses_18", label:"Реклама"},
            {id:"expenses_19", label:"Страхование"},
            {id:"expenses_22", label:"Юридические услуги"},
            {id:"expenses_24", label:"Мойка"},
            {id:"expenses_26", label:"Химчистка"},
            {id:"expenses_30", label:"Комиссия банка"},
            {id:"expenses_31", label:"Ремонт"},
            {id:"expenses_32", label:"Штрафы"},
            {id:"expenses_33", label:"Процент по экв"},
            {id:"expenses_34", label:"Прочее"},
            {id:"trade_in_car", label:"Автомобиль Trade-in"},
            {id:"trade_in_car_amount", label:"Сумма Trade-in"},
            {id:"sale_initial_payment", label:"ПВ факт"},
            {id:"credit_initial_payment", label:"ПВ по ДКП"},
            {id:"commission_payments_insurance", label:"КВ"},
            {id:"sale_amount", label:"Продажа"},
            {id:"cash", label:"Нал"},
            {id:"cashless", label:"Безнал"},
            {id:"profit", label:"Прибыль"},
            {id:"increase", label:"Наценка"},
            {id:"sale_manager", label:"Менеджер"},
            {id:"credit_manager", label:"Кред спец"},

        ];
        let items_slugs = _.map(items, i => i.id);

        return {
            all: items,
            default: items,
            added: ['credit_manager', 'increase'],
            roles: { // разрешенные столбцы по ролям
                admin: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
                head_of_call_center: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
                operator: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
                head_of_sales_department: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
                sales_manager: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
                head_of_credit_department: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
                credit_manager: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
                cashier: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
                investor: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
                supervisor: _.filter(items_slugs, i => ["increase"].indexOf(i) === -1),
            },
            permissions: {
                increase: ['operations.cars.increase'],
            }
        };
    }
    static affiliate_sales() {
        let items = [
            {id:"status", label:"Статус"},
            {id:"platform", label:"Площадка"},
            {id:"affiliate_program_company", label:"Юр лицо"},
            {id:"affiliate_program_category", label:"Категория"},
            {id:"affiliate_program", label:"Продукт"},
            {id:"document_number", label:"№ Документа"},
            {id:"document_date", label:"Дата"},
            {id:"buyer", label:"Покупатель"},
            {id:"sale_amount", label:"Сумма продажи"},
            {id:"fee_amount", label:"КВ"},
            {id:"manager", label:"Оформил"},
            {id:"comment", label:"Комментарий"},
        ];
        let items_slugs = _.map(items, i => i.id);


        return {
            all: items,
            default: items,
            added: [],
            roles: { // разрешенные столбцы по ролям
                admin: items_slugs,
                head_of_call_center: items_slugs,
                operator: items_slugs,
                head_of_sales_department: items_slugs,
                sales_manager: items_slugs,
                head_of_credit_department: items_slugs,
                credit_manager: items_slugs,
                cashier: items_slugs,
                investor: items_slugs,
                supervisor: items_slugs,
            },
        };
    }

    static report_affiliate_sales() {
        let items = [
            {id:"platform", label:"Площадка"},
            {id:"affiliate_program_company", label:"Юр лицо"},
            {id:"affiliate_program_category", label:"Категория"},
            {id:"affiliate_program", label:"Продукт"},
            {id:"sale_amount", label:"Сумма продажи"},
            {id:"fee_amount", label:"КВ"},
            {id:"count", label:"Кол-во"},
        ];
        let items_slugs = _.map(items, i => i.id);


        return {
            all: items,
            default: items,
            added: [],
            roles: { // разрешенные столбцы по ролям
                admin: items_slugs,
                head_of_call_center: items_slugs,
                operator: items_slugs,
                head_of_sales_department: items_slugs,
                sales_manager: items_slugs,
                head_of_credit_department: items_slugs,
                credit_manager: items_slugs,
                cashier: items_slugs,
                investor: items_slugs,
                supervisor: items_slugs,
            },
        };
    }

    static additional_agreements() {
        let items = [
            {id:"platform", label:"Площадка"},
            {id:"salon_legal_entity", label:"Юр лицо"},
            {id:"document_date", label:"Дата"},
            {id:"buyer", label:"Покупатель"},
            {id:"sale_amount", label:"Сумма доп оборудования"},
        ];
        let items_slugs = _.map(items, i => i.id);


        return {
            all: items,
            default: items,
            added: [],
            roles: { // разрешенные столбцы по ролям
                admin: items_slugs,
                head_of_call_center: items_slugs,
                operator: items_slugs,
                head_of_sales_department: items_slugs,
                sales_manager: items_slugs,
                head_of_credit_department: items_slugs,
                credit_manager: items_slugs,
                cashier: items_slugs,
                investor: items_slugs,
                supervisor: items_slugs,
            },
        };
    }

    static calls() {
        let items = [
            {id:"called_at", label:"Время вызова"},
            {id:"status", label:"Статус"},
            {id:"request_id", label:"Заявка ID"},
            {id:"request_fio", label:"Заявка ФИО"},
            {id:"src", label:"Кто звонил"},
            {id:"dst", label:"Набранный номер"},
            {id:"duration", label:"Длительность"},
            {id:"record", label:"Запись"},
            {id:"operator", label:"Оператор"},
            {id:"platform", label:"Площадка"},
            {id:"heard_human", label:"Услышали человека"},
        ];
        let items_slugs = _.map(items, i => i.id);

        return {
            all: items,
            default: items,
            added: ['request_id', 'request_fio', 'heard_human'],
            roles: { // разрешенные столбцы по ролям
                admin: items_slugs,
                head_of_call_center: items_slugs,
                operator: _.filter(items_slugs, i => ["src", "dst"].indexOf(i) === -1),
                head_of_sales_department: [],
                sales_manager: [],
                head_of_credit_department: [],
                credit_manager: [],
                cashier: [],
                investor: items_slugs,
            },
        };
    }

    static report_requests() {
        let items = [
            {id:"requests_per_day", label:"Заявок в сутки общие"},
            {id:"requests_credit_per_day", label:"Заявок в сутки на кредит"},
            {id:"requests", label:"Заявок всего"},
            {id:"requests_credit", label:"Заявки кредит"},
            {id:"come", label:"Пришло всего"},
            {id:"come_credit", label:"Пришло всего в Кредит"},
            {id:"requests_credit_come_credit_percent", label:"%% прихода кредит"},
            {id:"requests_come_percent", label:"%% прихода кредит+нал"},
            {id:"saw_manager", label:"Дошли до менеджеров кредит+нал"},
            {id:"checked_on_credit", label:"Забили в кредитном"},
            {id:"credit_approved", label:"Одобрено"},
            {id:"limits", label:"Лимитов"},
            {id:"checked_on_credit_credit_approved_percent", label:"%% Одобрения"},
            {id:"sale_credit", label:"Оформлено всего"},
            {id:"credit_approved_sale_credit_percent", label:"%% Оформ. В кредит"},
            {id:"not_saw_manager_percent", label:"%% недошедших до менеджера кредит+нал"},
            {id:"not_saw_credit_manager_percent", label:"%% недошедших до кредитного"},
            {id:"saw_credit_manager_percent", label:"Дошли до кредитного отдела"},
            {id:"requests_credit_sale_credit_percent", label:"Конверсия от начала до конца кредитные"},
            {id:"requests_sale_credit_percent", label:"Конверсия от всех до конца кредитных продаж"},
        ];

        return {
            all: items,
            default: items,
            added: [],
        };
    }
    static report_requests_regions() {
        let items = [
            {id:"requests", label:"Заявок"},
            {id:"come", label:"Пришло"},
            {id:"come_credit", label:"Пришло всего в Кредит"},
            {id:"requests_come_percent", label:"Конверсия"},
            {id:"percent_of_all", label:"% от всех"},
            {id:"saw_manager", label:"Дошли до менеджеров кредит+нал"},
            {id:"checked_on_credit", label:"Забили в кредитном"},
            {id:"credit_approved", label:"Одобрено"},
            {id:"checked_on_credit_credit_approved_percent", label:"%% Одобрения"},
            {id:"sale_credit", label:"Оформлено всего"},
            {id:"credit_approved_sale_credit_percent", label:"%% Оформ. В кредит"},
            {id:"saw_credit_manager_percent", label:"Дошли до кредитного отдела"},
        ];

        return {
            all: items,
            default: items,
            added: [
                "come_credit",
                "saw_manager",
                "checked_on_credit",
                "credit_approved",
                "checked_on_credit_credit_approved_percent",
                "sale_credit",
                "credit_approved_sale_credit_percent",
                "saw_credit_manager_percent",
            ],
        };
    }
    static report_departments_sales() {
        let items = [
            {id:"margin_with_cost_increase", label:"Маржа с удорожанием"},
            {id:"margin_without_cost_increase", label:"Маржа без удорожания"},
            {id:"percent_from_margin_with_cost_increase", label:"Сумма % от маржи с удорожанием"},
            {id:"percent_from_margin_without_cost_increase", label:"Сумма % от маржи без удорожания"},
        ];

        return {
            all: items,
            default: items,
            added: [],
        };
    }
    static report_departments_credit() {
        let items = [
            {id:"requests", label:"Принято"},
            {id:"sended", label:"Отправлено"},
            {id:"limit", label:"Лимитов"},
            {id:"approved", label:"Одобрено"},
            {id:"percent_approved", label:"% одобрения"},
            {id:"issued", label:"Оформлено"},
            {id:"percent_issued", label:"% оформления"},
        ];
        return {
            all: items,
            default: items,
            added: [],
        };
    }

    static report_departments_call_center() {
        let items = [
            {id: "requests", label: "Заявок всего"},
            {id: "requests_type_credit", label: "Заявок в кредит"},
            {id: "requests_type_cash", label: "Заявок наличные"},
            {id: "requests_type_none", label: "Заявок не определен"},
            {id: "requests_status_new", label: "Новый"},
            {id: "requests_status_in_work", label: "В работе"},
            {id: "requests_status_not_answer", label: "Не отвечает"},
            {id: "requests_status_non_call", label: "Недозвон"},
            {id: "requests_status_arrived", label: "В салоне"},
            {id: "requests_status_not_marked_in_salon", label: "В салоне не отмечен"},
            {id: "requests_status_bought", label: "Купил"},
            {id: "requests_status_will_arrive", label: "Приедет"},
            {id: "requests_status_approve", label: "Фильтр"},
            {id: "requests_status_rejection", label: "Отказ"},
            {id: "requests_status_incorrect_data", label: "Некорр.данные"},
            {id: "param1", label: "Заявок всего в статусах новый, в работе, в салоне, в салоне не отмечен, купил, приедет, отказ"},
            {id: "param2", label: "Кол-во записей на приезд все статусы"},
            {id: "param3", label: "Кол-во записей на приезд в статусах новый, в работе, в салоне, в салоне не отмечен, купил, приедет, отказ"},
            {id: "param4", label: "Приехало из текущих заявок на площадку"},
        ];
        return {
            all: items,
            default: items,
            added: [],
        };
    }
    static report_departments_call_center_calls() {
        let items = [
            {id: "calls", label: "Всего звонков"},
            {id: "calls_answered", label: "Отвеч.звонков"},
            {id: "calls_answered_percent", label: "% Отвеч.звонков"},
            {id: "ended_operator", label: "Оператор положил трубку"},
            {id: "ended_operator_percent", label: "% Опер положил трубку"},
            {id: "duration", label: "Время диалога"},
            {id: "duration_avg", label: "Ср.время диалога"},
        ];
        return {
            all: items,
            default: items,
            added: [],
        };
    }

    static report_agency() {
        let items = [
            {id: "balance", label: "Баланс"},
            {id: "expense", label: "Траты"},
            {id: "payment", label: "Приходы"},
            {id: "requests", label: "Заявок"},
            {id: "requests_type_credit", label: "Заявок в кредит"},
            {id: "requests_visited", label: "В салоне"},
            {id: "requests_visited_type_credit", label: "В салоне (кредит)"},
            {id: "requests_visited_credit_department", label: "В кредитном"},
            {id: "requests_credit_approved", label: "Одобрено"},
            {id: "requests_bought_credit", label: "Оформлено (кредит)"},
            {id: "requests_bought_cash", label: "Оформлено (нал)"},
            {id: "requests_visited_percent", label: "Приход (общий), %"},
            {id: "requests_visited_type_credit_percent", label: "Приход (кредит), %"},
            {id: "requests_visited_credit_department_percent", label: "Довели до КО, %"},
            {id: "requests_credit_approved_percent", label: "Одобрено, %"},
            {id: "requests_bought_credit_percent", label: "Подписание, %"},
            {id: "cost_request", label: "Цена заявки"},
            {id: "cost_request_visited", label: "Цена прихода"},
            {id: "cost_request_credit_approved", label: "Цена добра"},
            {id: "cost_request_bought", label: "Цена продажи"},
        ];
        return {
            all: items,
            default: items,
            added: ['balance', 'payment'],
        };
    }

    static report_agency2() {
        let items = [
            {id: "balance", label: "Баланс"},
            {id: "expense", label: "Траты"},
            {id: "payment", label: "Приходы"},
            {id: "requests", label: "Заявок"},
            {id: "requests_shipped", label: "Отгружено"},
            {id: "requests_doubles", label: "Дубли"},
            {id: "requests_spam", label: "Спам"},
            {id: "requests_status_incorrect_data", label: "Некорр. данные"},
            {id: "requests_type_credit", label: "Заявок в кредит"},
            {id: "requests_visited", label: "В салоне"},
            {id: "requests_visited_type_credit", label: "В салоне (кредит)"},
            {id: "requests_visited_credit_department", label: "В кредитном"},
            {id: "requests_credit_approved", label: "Одобрено"},
            {id: "requests_bought_credit", label: "Оформлено (кредит)"},
            {id: "requests_bought_cash", label: "Оформлено (нал)"},
            {id: "requests_visited_percent", label: "Приход (общий), %"},
            {id: "requests_visited_type_credit_percent", label: "Приход (кредит), %"},
            {id: "requests_visited_credit_department_percent", label: "Довели до КО, %"},
            {id: "requests_credit_approved_percent", label: "Одобрено, %"},
            {id: "requests_bought_credit_percent", label: "Подписание, %"},
            {id: "cost_request", label: "Цена заявки"},
            {id: "cost_request_visited", label: "Цена прихода"},
            {id: "cost_request_credit_approved", label: "Цена добра"},
            {id: "cost_request_bought", label: "Цена продажи"},
        ];
        return {
            all: items,
            default: items,
            added: [],
        };
    }


    static report_banks() {
        let items = [
            {id: "all", label: "Всего"},
            {id: "sent", label: "Отправили"},
            {id: "approved", label: "Одобрено"},
            {id: "limit", label: "Лимит"},
            {id: "approved_percent", label: "% Одобренных"},
            {id: "issued", label: "Оформлено"},
            {id: "issued_percent", label: "% Оформленных"},
            {id: "rassmotrenie", label: "Рассмотрение"},
            {id: "otkaz", label: "Отказ"},
            {id: "otkaz_skoring", label: "Отказ скоринг"},
            {id: "otkaz_ds", label: "Отказ ДС"},
            {id: "np_vozrast", label: "НП возраст"},
            {id: "np_region", label: "НП регион"},
            {id: "np_vu", label: "НП ВУ"},
            {id: "np_fssp", label: "НП ФССП"},
            {id: "odobren", label: "Одобрен"},
            {id: "limit_po_klientu", label: "Лимит по клиенту"},
            {id: "limit_po_ts", label: "Лимит по ТС"},
            {id: "soglasovanie_ts", label: "Согласование ТС"},
            {id: "ozidanie", label: "Ожидание"},
            {id: "dokumenty_gotovy", label: "Документы готовы"},
            {id: "ne_otpravljat", label: "Не отправлять"},
            {id: "chernovik", label: "Черновик"},
            {id: "skoring_otpravit", label: "Скоринг отправить"},
        ];
        let default_ids = ["all", "sent", "approved", "limit", "approved_percent", "issued", "issued_percent",]

        return {
            all: items,
            default: _.map(default_ids, id => _.find(items, {id: id})),
            added: [],
        };
    }

}

export default ColumnsData;
